<template>
    <frameset rows="88,*" cols="*" frameborder="no" border="0" framespacing="0">
        <frame src="/topindex" name="topFrame" scrolling="No" noresize="noresize" id="topFrame" title="topFrame" />
        <frameset cols="187,*" frameborder="no" border="0" framespacing="0">
            <frame src="/aboutusleft" name="leftFrame" scrolling="auto" noresize="noresize" id="leftFrame" title="leftFrame" />
            <frame src="/2officeintroduction" name="rightFrame" id="rightFrame" title="rightFrame" />
        </frameset>
    </frameset>
</template>

<script>

export default {
    data(){
        return{

        }
    },
    methods: {

    }
}

</script>


// WEBPACK FOOTER //
// src/components/shouye/aboutus.vue